import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const SectionTitle = ({ className, tilteInfo }) => {
  const { subTitle, title, description } = tilteInfo;

  return (
    <Box className={`${className || ''}`}>
      {subTitle && (
        <span className="font-normal text-xl uppercase tracking-widest text-gray-500">
          {subTitle}
        </span>
      )}
      {title && (
        <h2 className="text-2xl sm:text-3xl md:4xl capitalize my-2">{title}</h2>
      )}
      {description && <p className="mt-5">{description}</p>}
    </Box>
  );
};

SectionTitle.propTypes = {
  className: PropTypes.string,
  tilteInfo: PropTypes.object,
};

export default SectionTitle;
